// Grade do Balcão: todas as categorias em sequência, cada uma com o título
// preso no alto enquanto se rola por ela. Com a busca preenchida vira a lista
// do que casou (de todas as categorias), sem os títulos. O contêiner é o único
// lugar da página que rola. A última seção tem no mínimo a altura da grade:
// sem isso, clicar numa categoria curta do fim não a trazia até o topo.
import { Search } from "lucide-react";

import { CarregandoGrade } from "../../../components/carregando";

import CardProduto from "./CardProduto";

/** Produtos agrupados na ordem das categorias; sem categoria vão para "Outros". */
export function montarSecoes(products, categoryList) {
  const porCategoria = new Map(categoryList.map((c) => [c, []]));
  const semCategoria = [];
  for (const p of products) {
    if (p.category && porCategoria.has(p.category)) porCategoria.get(p.category).push(p);
    else semCategoria.push(p);
  }
  const lista = [...porCategoria].filter(([, itens]) => itens.length).map(([nome, itens]) => ({ nome, itens }));
  if (semCategoria.length) lista.push({ nome: "Outros", itens: semCategoria });
  return lista;
}

const GRADE = "grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-3";

export default function GradeCategorias({ ctx, rolagem, secoes }) {
  const { products, filteredProducts, buscaAberta, primeiraCarga, getProductPromo, abrirProduto, cashbackAtivo, cashbackCfg } = ctx;

  const card = (p) => (
    <CardProduto key={p.id} product={p} promo={getProductPromo(p)} cashbackPct={cashbackAtivo && !getProductPromo(p) ? cashbackCfg?.percentual : null} onClick={() => abrirProduto(p)} />
  );

  let conteudo;
  if (primeiraCarga) {
    // 1ª abertura: a grade com foto em cinza (o Balcão é sempre escuro, daí o
    // "dark" — as peças usam as cores do tema). As releituras depois de cada
    // venda não voltam a ela.
    conteudo = <div className="dark py-4"><CarregandoGrade comImagem quantos={10} className={GRADE} /></div>;
  } else if ((buscaAberta ? filteredProducts : products).length === 0) {
    conteudo = <div className="flex flex-col items-center justify-center h-64 text-zinc-400"><Search className="w-12 h-12 mb-3" /><p className="text-lg">Nenhum produto encontrado</p></div>;
  } else if (buscaAberta) {
    conteudo = <div className={`${GRADE} py-4`}>{filteredProducts.map(card)}</div>;
  } else {
    conteudo = secoes.map((s) => (
      <section key={s.nome} ref={rolagem.registrarSecao(s.nome)} data-e2e="secao-categoria" data-categoria={s.nome} className="pb-4 last:min-h-full">
        <h3 className="sticky top-0 z-10 -mx-4 px-4 py-2 mb-3 bg-zinc-950/95 backdrop-blur text-sm font-black uppercase tracking-wider text-zinc-300 border-b border-zinc-800">
          {s.nome} <span className="text-zinc-600 font-semibold normal-case tracking-normal">· {s.itens.length}</span>
        </h3>
        <div className={GRADE}>{s.itens.map(card)}</div>
      </section>
    ));
  }

  return (
    <div ref={rolagem.containerRef} onScroll={rolagem.aoRolar} className="relative flex-1 min-h-0 overflow-y-auto px-4" data-e2e="balcao-grade">
      {conteudo}
    </div>
  );
}
